// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-document-dialog',
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        documentID: {
            type: String,
            required: false,
            default: ''
        },
        documentType: {
            type: String,
            required: false,
            default: ''
        }
    },
    // #endregion
    // #region Data
    data: () => ({
        document: null,
        activeItem: 0,
    }),
    // #endregion
    // #region Boostrap
    beforeMount() {
        this.loadData();
    },
    // #endregion
    // #region Methods
    methods: {
        async loadData() {
            try {
                let tData = await this.$host.api.get(`commerce/history/${this.documentType}/${this.documentID}/details`);
                if (!tData.data) {
                    return;
                }
                this.document = tData.data;
            }
            catch (e) {
                this.$host.notification.showError(e);
            }
        },
        setActive(index) {
            this.activeItem = index;
        }
    }
    // #endregion
});
// #endregion
